import { FormControl, FormLabel, RadioGroup, RadioGroupProps } from '@mui/material';
import React from 'react';

import { EntityOnChange } from 'app/type';

type EntityRadioFieldProps<T extends object> = Omit<RadioGroupProps, 'onChange' | 'value'> & {
    name: keyof T;
    label: string;
    value: T;
    onChange?: EntityOnChange<T>;
};

export const EntityRadioField = <T extends object>(props: EntityRadioFieldProps<T>): React.ReactElement => {
    const { label, value, name, onChange, children, ...rest } = props;

    const handleEntityChange = (evt: React.ChangeEvent<HTMLInputElement>, newValue: string): void => {
        onChange?.(evt, evt.target.name as keyof T, newValue);
    };

    return (
        <FormControl>
            <FormLabel>{label}</FormLabel>
            <RadioGroup {...rest} name={name} value={value[name]} onChange={handleEntityChange}>
                {children}
            </RadioGroup>
        </FormControl>
    );
};
